import { c as _c } from "react/compiler-runtime";
import { Select } from '@base-ui/react/select';
import { css } from '@repo/pandacss/css';
import { usePageAction } from '@repo/platform-analytics/hooks/usePageAction';
import { ChevronIcon } from '@repo/ui/icons/ChevronIcon';
import { DEFAULT_LABEL, type GoalOption, options } from '../../../../config';
export function GoalSelect(t0) {
  const $ = _c(11);
  const {
    selectedOption,
    setSelectedOption
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      actionName: "primaryGoal",
      actionSection: "jump_page_hero",
      actionType: "select"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const firePrimaryGoalSelectedPageAction = usePageAction(t1);
  let t2;
  if ($[1] !== firePrimaryGoalSelectedPageAction || $[2] !== setSelectedOption) {
    t2 = next => {
      firePrimaryGoalSelectedPageAction({
        action_input: next
      });
      setSelectedOption((next ?? "") as GoalOption);
    };
    $[1] = firePrimaryGoalSelectedPageAction;
    $[2] = setSelectedOption;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = css({
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      flex: "1",
      minH: "[2.5rem]",
      px: "3",
      rounded: "sm",
      border: "[1px solid {colors.neutral.light}]",
      bg: "common.white",
      textStyle: "body",
      textAlign: "left",
      cursor: "pointer",
      gap: "2",
      md: {
        minW: "[300px]"
      },
      _hover: {
        borderColor: "neutral.dark"
      },
      _focusVisible: {
        outline: "[2px solid {colors.blues.main}]",
        outlineOffset: "[2px]"
      }
    });
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Select.Value>{_temp}</Select.Value>;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Select.Trigger className={t3} aria-label={DEFAULT_LABEL}>{t4}<Select.Icon className={css({
        display: "inline-flex",
        alignItems: "center",
        color: "neutral.dark",
        transition: "transform",
        "&[data-popup-open]": {
          transform: "rotate(180deg)"
        }
      })}><ChevronIcon position="down" /></Select.Icon></Select.Trigger>;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Select.Portal><Select.Positioner sideOffset={4} alignItemWithTrigger={false}><Select.Popup className={css({
          bg: "common.white",
          rounded: "sm",
          boxShadow: "[0 4px 8px 0 rgb(100 102 106 / 0.15), 0 8px 16px 0 rgb(100 102 106 / 0.33)]",
          border: "[1px solid {colors.neutral.lighter}]",
          py: "2",
          minW: "[var(--anchor-width)]",
          outline: "none",
          zIndex: "[1]"
        })}>{options.map(_temp2)}</Select.Popup></Select.Positioner></Select.Portal>;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== selectedOption || $[9] !== t2) {
    t7 = <Select.Root modal={false} items={options} value={selectedOption} onValueChange={t2}>{t5}{t6}</Select.Root>;
    $[8] = selectedOption;
    $[9] = t2;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  return t7;
}
function _temp2(opt_0) {
  return <Select.Item key={opt_0.value} value={opt_0.value} className={css({
    display: "flex",
    alignItems: "center",
    px: "3",
    py: "2",
    textStyle: "body",
    color: "neutral.darkest",
    cursor: "pointer",
    outline: "none",
    "&[data-highlighted]": {
      bg: "neutral.lightest"
    },
    "&[data-selected]": {
      bg: "greens.lightest",
      color: "greens.dark"
    }
  })}><Select.ItemText>{opt_0.label}</Select.ItemText></Select.Item>;
}
function _temp(value) {
  if (!value) {
    return <span className={css({
      color: "neutral.light"
    })}>{DEFAULT_LABEL}</span>;
  }
  const match = options.find(opt => opt.value === value);
  return <span className={css({
    color: "neutral.darkest"
  })}>{match?.label ?? DEFAULT_LABEL}</span>;
}